// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5475b1bf","79":"4769f790","471":"944e3b5d","555":"5247cbe4","753":"9291ad09","909":"31abd2b2","982":"52039e79"}[chunkId] + ".chunk.js";
};